<template>
  <header class="kn-topbar">
    <div class="kn-topbar__left">
      <button type="button" class="kn-icon-btn kn-topbar__burger" aria-label="Открыть меню" @click="$emit('toggle-sidebar')">
        <i class="fas fa-bars"></i>
      </button>

      <button type="button" class="kn-topbar__search" @click="$emit('open-search')">
        <i class="fas fa-search"></i>
        <span class="kn-topbar__search-text">Поиск по разделам…</span>
        <kbd class="kn-topbar__kbd">{{ isMac ? '⌘' : 'Ctrl' }} K</kbd>
      </button>
    </div>

    <div class="kn-topbar__right">
      <el-tooltip :content="theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'" placement="bottom" :open-delay="300">
        <button type="button" class="kn-icon-btn" :aria-label="theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'" @click="toggleTheme">
          <i :class="theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'"></i>
        </button>
      </el-tooltip>

      <component v-if="actionsTemplate" :is="actionsTemplate"></component>

      <template v-else>
        <deputy-modal
          v-if="$canAndRulesPass(user, $permissions.USER.DEPUTIES_LOGIN)"
          class="kn-topbar__deputy"
        ></deputy-modal>

        <div class="kn-icon-btn kn-topbar__notifications">
          <notifications :user-id="user.id"></notifications>
        </div>

        <el-dropdown trigger="click" placement="bottom-end" @command="onUserCommand">
          <button type="button" class="kn-topbar__user">
            <span class="kn-avatar">{{ initials }}</span>
            <span class="kn-topbar__user-name">{{ user.last_name }} {{ user.first_name }}</span>
            <i class="fas fa-chevron-down kn-topbar__user-caret"></i>
          </button>
          <el-dropdown-menu slot="dropdown" class="kn-user-dropdown">
            <div class="kn-user-dropdown__head">
              <div class="kn-user-dropdown__name">{{ user.last_name }} {{ user.first_name }} {{ user.middle_name }}</div>
              <div v-if="user.email" class="kn-user-dropdown__email">{{ user.email }}</div>
            </div>
            <el-dropdown-item command="logout" icon="fas fa-sign-out-alt">Выйти</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
  </header>
</template>

<script>
import {mapGetters} from "vuex";
import Notifications from "@/components/Notifications.vue";
import DeputyModal from "@/auth/DeputyModal.vue";

export default {
  name: "app-topbar",
  components: {DeputyModal, Notifications},
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('settings', ['theme']),
    actionsTemplate() {
      return this.$companyConfiguration.settings.getActionsTemplate();
    },
    initials() {
      const first = (this.user.first_name || '').charAt(0);
      const last = (this.user.last_name || '').charAt(0);
      return (last + first).toUpperCase() || '?';
    },
    isMac() {
      return /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
    },
  },
  methods: {
    toggleTheme() {
      this.$store.commit('settings/setTheme', this.theme === 'dark' ? 'light' : 'dark');
    },
    onUserCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('logoutUser');
        this.$router.push({name: 'Login'});
      }
    },
  },
}
</script>

<style lang="scss">
.kn-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: var(--kn-radius-btn);
  background: transparent;
  color: var(--kn-text-muted);
  font-size: 16px;
  cursor: pointer;
  transition: background-color .15s ease, color .15s ease;

  &:hover {
    background-color: var(--kn-hover);
    color: var(--kn-text);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--kn-primary-ring);
  }
}

.kn-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--kn-primary), #A78BFA);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .02em;
}

.kn-topbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: var(--kn-topbar-height);
  padding: 0 24px;
  background-color: var(--kn-bg);
  border-bottom: 1px solid var(--kn-border);
  box-sizing: border-box;

  &__left, &__right {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  &__left { flex: 1; }

  &__burger { display: none !important; }

  &__search {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 420px;
    height: 40px;
    padding: 0 8px 0 14px;
    border: 1px solid var(--kn-border);
    border-radius: var(--kn-radius-btn);
    background-color: var(--kn-card);
    color: var(--kn-text-faint);
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:hover { border-color: var(--kn-primary); }
    &:focus-visible { outline: none; box-shadow: 0 0 0 3px var(--kn-primary-ring); }
  }

  &__search-text { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  &__kbd {
    padding: 2px 8px;
    border: 1px solid var(--kn-border);
    border-radius: 6px;
    background-color: var(--kn-card-muted);
    color: var(--kn-text-muted);
    font-family: inherit;
    font-size: 11px;
    font-weight: 600;
  }

  &__notifications {
    .notifications-popover-badge {
      font-size: 17px !important;
      line-height: 1;
    }
  }

  &__deputy {
    .el-button.table-action-button {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }
  }

  &__user {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 44px;
    padding: 0 10px 0 6px;
    border: 0;
    border-radius: var(--kn-radius-btn);
    background: transparent;
    color: var(--kn-text);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:hover { background-color: var(--kn-hover); }
  }

  &__user-name { white-space: nowrap; }

  &__user-caret { font-size: 10px; color: var(--kn-text-faint); }
}

.kn-user-dropdown {
  min-width: 220px;
  padding: 6px 0 !important;

  &__head {
    padding: 8px 18px 10px;
    margin-bottom: 4px;
    border-bottom: 1px solid var(--kn-border);
  }

  &__name { font-weight: 600; color: var(--kn-text); }

  &__email { font-size: 12px; color: var(--kn-text-muted); margin-top: 2px; }
}

@media (max-width: 1023px) {
  .kn-topbar {
    padding: 0 12px;

    &__burger { display: inline-flex !important; }
  }
}

@media (max-width: 767px) {
  .kn-topbar {
    &__search-text, &__kbd, &__user-name, &__user-caret { display: none; }
    &__search {
      width: 40px;
      padding: 0;
      justify-content: center;
      border-color: transparent;
      background: transparent;
    }
  }
}
</style>
